module.exports={
  "karen-bass": {
    "name": "Karen Bass",
    "lastName": "Bass",
    "label": "KB",
    "image": "karen-bass.png",
    "party": "D",
    "pronoun": "ella",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  },
  "rick-caruso": {
    "name": "Rick Caruso",
    "lastName": "Caruso",
    "label": "RC",
    "image": "rick-caruso.png",
    "party": "U",
    "pronoun": "él",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  }
}